import { useEffect, useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { useOtherSettings } from '@namespace/cms/src/hooks/useOtherSettings';
import { getLocalStorageValue, LOCAL_STORAGE_KEYS } from '@namespace/helpers';
import { getABTestWithAdd } from '../../api/getABTestWithAdd';
import { abTestActions } from '../../store';

const { ADD_SEGMENTS_AB_TEST } = abTestActions;

const useInitSegmentABTests = () => {
  const deviceId = getLocalStorageValue(LOCAL_STORAGE_KEYS.AB_TEST_DEVICE_ID);
  const { abTestSegments = [] } = useOtherSettings();
  const filteredTests = useMemo(
    () =>
      abTestSegments
        .filter((test) => test?.isAddOnPageInit)
        .map(({ isAddOnPageInit, ...rest }) => rest),
    [abTestSegments]
  );

  useEffect(() => {
    if (deviceId && !isEmpty(filteredTests)) {
      const fetchABTest = async () => {
        const { data = [] } = await getABTestWithAdd(deviceId, filteredTests);
        ADD_SEGMENTS_AB_TEST(data);
      };

      fetchABTest();
    }
  }, [deviceId, filteredTests]);
};

export default useInitSegmentABTests;
